import React from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentsDemoPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes glow {
          0%,100% { box-shadow: 0 0 25px rgba(0,242,255,.25); }
          50% { box-shadow: 0 0 70px rgba(0,242,255,.8); }
        }

        @keyframes float {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-12px); }
        }

        @keyframes scan {
          0% { transform: translateX(-130%); opacity: 0; }
          35% { opacity: 1; }
          100% { transform: translateX(130%); opacity: 0; }
        }

        @keyframes pulse {
          0%,100% { transform: scale(1); }
          50% { transform: scale(1.06); }
        }
      `}</style>

      <button onClick={() => navigate(-1)} style={styles.back}>
        ← Retour
      </button>

      <div style={styles.iconBox}>
        <span style={styles.icon}>🔐</span>
      </div>

      <h1 style={styles.title}>Paiements encadrés</h1>

      <p style={styles.subtitle}>
        Une logique pensée pour Android, iOS et les règles des plateformes.
      </p>

      <div style={styles.card}>
        <div style={styles.scanLine} />

        <div style={styles.platforms}>
          <div style={styles.platform}>Android</div>
          <div style={styles.secure}>Paiement sécurisé</div>
          <div style={styles.platform}>iOS</div>
        </div>

        <div style={styles.steps}>
          <div style={styles.step}>1. Choix du pack</div>
          <div style={styles.step}>2. Validation plateforme</div>
          <div style={styles.step}>3. Coins crédités</div>
        </div>
      </div>

      <div style={styles.info}>
        Les achats de coins sont encadrés pour respecter les règles Android et iOS.
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top right, rgba(0,242,255,.22), transparent 34%), radial-gradient(circle at bottom left, rgba(0,145,255,.18), transparent 32%), #03070d",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    padding: "32px 18px",
    textAlign: "center",
  },

  back: {
    position: "fixed",
    top: 22,
    left: 22,
    padding: "11px 18px",
    borderRadius: 16,
    border: "1px solid rgba(0,242,255,.45)",
    background: "rgba(0,12,20,.9)",
    color: "#00f2ff",
    fontWeight: 900,
    cursor: "pointer",
  },

  iconBox: {
    width: 125,
    height: 125,
    margin: "80px auto 28px",
    borderRadius: "50%",
    border: "2px solid rgba(0,242,255,.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: "glow 2.5s infinite",
  },

  icon: {
    fontSize: 54,
    animation: "float 2.5s ease-in-out infinite",
  },

  title: {
    fontSize: 54,
    color: "#00f2ff",
    textShadow: "0 0 25px rgba(0,242,255,.8)",
    marginBottom: 12,
  },

  subtitle: {
    maxWidth: 760,
    margin: "0 auto 35px",
    fontSize: 21,
    color: "#9befff",
    lineHeight: 1.6,
  },

  card: {
    position: "relative",
    overflow: "hidden",
    maxWidth: 900,
    margin: "0 auto",
    padding: 28,
    borderRadius: 28,
    background: "rgba(0,12,20,.82)",
    border: "1px solid rgba(0,242,255,.35)",
    boxShadow: "0 0 35px rgba(0,242,255,.18)",
  },

  scanLine: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(110deg, transparent 20%, rgba(0,242,255,.14) 50%, transparent 75%)",
    animation: "scan 3s infinite",
  },

  platforms: {
    position: "relative",
    zIndex: 2,
    display: "grid",
    gridTemplateColumns: "1fr 1.2fr 1fr",
    gap: 16,
    alignItems: "center",
    marginBottom: 24,
  },

  platform: {
    padding: "22px 14px",
    borderRadius: 22,
    background: "rgba(0,242,255,.08)",
    border: "1px solid rgba(0,242,255,.35)",
    fontSize: 24,
    fontWeight: 900,
  },

  secure: {
    padding: "26px 14px",
    borderRadius: 26,
    background: "linear-gradient(180deg, rgba(0,242,255,.22), rgba(0,12,20,.9))",
    border: "2px solid rgba(0,242,255,.75)",
    color: "#00f2ff",
    fontSize: 25,
    fontWeight: 900,
    animation: "pulse 2.4s infinite",
  },

  steps: {
    position: "relative",
    zIndex: 2,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
    gap: 14,
  },

  step: {
    padding: 16,
    borderRadius: 18,
    background: "rgba(255,255,255,.05)",
    border: "1px solid rgba(0,242,255,.22)",
    color: "#dffcff",
    fontWeight: 800,
  },

  info: {
    maxWidth: 760,
    margin: "28px auto 0",
    padding: 18,
    borderRadius: 20,
    background: "rgba(0,242,255,.08)",
    border: "1px solid rgba(0,242,255,.28)",
    color: "#cfffff",
    fontSize: 18,
  },
};
